import { render, staticRenderFns } from "./FtpAccountDetail.vue?vue&type=template&id=66d660f0&"
import script from "./FtpAccountDetail.vue?vue&type=script&lang=js&"
export * from "./FtpAccountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports